import { useEffect, useState } from "react";
import { CalendarClock, MessageSquare } from "lucide-react";
import { BOOKING_PATH } from "@/lib/site";
import { useLang } from "@/i18n/LanguageContext";
import { trackClick } from "@/lib/track";

// Mobile/tablet only sticky CTA bar. Appears after the hero and hides when the
// contact section is in view (so it never covers the form).
export const StickyMobileCTA = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.9;
      const contact = document.getElementById("kontakt");
      let reachedContact = false;
      if (contact) {
        const r = contact.getBoundingClientRect();
        // Hide as soon as the contact section reaches the viewport, and keep it
        // hidden while the user is on or below it (so it never covers the form
        // and does not pop back up over the footer).
        reachedContact = r.top < window.innerHeight;
      }
      setShow(past && !reachedContact);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 p-3 transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
      data-testid="sticky-mobile-cta"
    >
      <div className="glass rounded-2xl p-2 flex gap-2 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.9)]">
        <a href="#kontakt" onClick={() => trackClick("contact")} className="btn-ghost flex-1 !py-2.5 justify-center text-sm" data-testid="sticky-contact">
          <MessageSquare size={15} /> {t.finalCta.contact}
        </a>
        <a href={`${BOOKING_PATH}?src=sticky`} onClick={() => trackClick("book_time")} className="btn-primary flex-1 !py-2.5 justify-center text-sm" data-testid="sticky-book">
          <CalendarClock size={15} /> {t.nav.book}
        </a>
      </div>
    </div>
  );
};
